export const ScriptLibraryOrder = {
  MOST_RECENT: 'MOST_RECENT',
  MOST_RELEVANT: 'MOST_RELEVANT',
  LAST_VIEWED: 'LAST_VIEWED',
  DOWNLOADS_ASC: 'DOWNLOADS_ASC',
  DOWNLOADS_DESC: 'DOWNLOADS_DESC',
}
